import { Button, Col, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { BREACK_POINT_HEADER, PROPERTY_TYPE } from "../../../common/constant";
import { addProductToCart } from "../../../redux/reducers/slice/cart";
import NotificationAddToCartSuccess from "../../notification";
import "./style.scss";

const ProductAddToCart = (props: any) => {
  const { product, productInfo, currentOption, currentGift, quantity } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleAddToCart = async (prod: any, data: any) => {
    const _data = {
      _id: prod.product_cat_id,
      slug: prod.slug || "",
      cat_id_v2: prod.product_cat_id,
      code: data.value,
      disable_buy_button: data.disable_buy_button,
      disable_buy_button_message: data.disable_buy_button_message,
      feature: {
        currency: "VNĐ",
        discount_percent: data.discount_percent,
        feature_id: data.feature_id,
        price: data.price,
        price_promotion: data.price_promotion,
        price_save: data.price_save,
        product_cat_id: prod.parent_id,
        spec: data.label,
      },
      // gift_quantity: 1,
      product_property: currentOption,
      product_gifts: currentGift ? currentGift.promotion_products : null,
      img: getImage(),
      name: getName(),
      services: prod.services,
      wish: false,
      category_name: prod.category_name,
    };

    const addToCartResponse = await dispatch(
      addProductToCart(_data, true, quantity)
    );

    if (!addToCartResponse) {
      NotificationAddToCartSuccess({
        productName: getName(),
        productFeature: data.label,
      });

      const classNameViewCart =
        window.innerWidth > BREACK_POINT_HEADER
          ? "kd-shopping-cart"
          : "kd-shopping-cart-mobile";

      let viewCart: any = document.getElementsByClassName(classNameViewCart)[0];

      viewCart.style = "";

      viewCart.classList.add("cart-animation");

      setTimeout(function () {
        viewCart.classList.remove("cart-animation");
      }, 800);
    }
  };

  const getImage = () => {
    let path = product.img;

    if (currentOption[PROPERTY_TYPE.image]) {
      path =
        currentOption[PROPERTY_TYPE.image].img ||
        currentOption[PROPERTY_TYPE.image].image;
    }

    return path;
  };

  const getName = () => {
    let name = product.name;

    if (currentOption[PROPERTY_TYPE.type]) {
      name = currentOption[PROPERTY_TYPE.type].label;
    }

    return name;
  };

  return (
    <Row align="middle" justify="end" className="product-add-to-cart-wrapper">
      <Col span={24}>
        <Row
          align="middle"
          justify="space-between"
          className="product-add-to-cart-item-wrapper">
          <Col flex="auto" className="btn-pay-now-wrapper">
            <Button
              className="btn-pay-now sub-title"
              onClick={() => handleAddToCart(product, productInfo)}>
              {t("label_add_to_cart")}
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ProductAddToCart;
